export default __webpack_public_path__ + "static/media/Xplir_logo_rgb.51b4f4c5.svg";